import { computed } from 'vue';
import useLocale from './composables/useLocale';

const useCollectionName = () => {
  const { t } = useLocale();

  const collectionName = computed(() => (name?: string) => {
    if (!name) {
      return '';
    }
    // We have hardcoded name from backend which is hard to update
    if (name === 'Favourites') {
      return t('predefined_bookshelf_favorites');
    }
    if (name.length > 0 && name.charAt(0) === '_') {
      return t(`${name.substring(1)}`);
    }
    return name;
  });

  return {
    collectionName,
  };
};
export default useCollectionName;
